export const mountCanvasText = ({ text, canvas, width, lineHeight }) => {
    const words = text.split(' ');
    const lines = [];

    const maxWidth = 19;

    let currentLineText = '';

    words.forEach(word => {
        if (word.length > maxWidth) {
            if (currentLineText.trim() !== '') {
                lines.push(currentLineText);
                currentLineText = '';
            }

            let start = 0;

            while (start < word.length) {
                let end = start + maxWidth;

                if (end > word.length) end = word.length;

                lines.push(word.substring(start, end));

                start = end;
            }
        } else {
            if ((currentLineText + word).length > maxWidth) {
                lines.push(currentLineText);

                currentLineText = word + ' ';
            } else {
                currentLineText += word + ' ';
            }
        }
    });

    if (currentLineText.trim() !== '') {
        lines.push(currentLineText);
    }

    fillCanvasText(canvas, width, lineHeight, lines);
};

const fillCanvasText = (canvas, width, lineHeight, lines) => {
	const heightStart = 5 - lines.length;

	const x = (width / 2);
	let y = heightStart === 4 ? (heightStart - 1) * lineHeight : heightStart * lineHeight;

	setCanvasFillConfig(canvas, heightStart);

	lines.forEach(text => {
		canvas.fillText(text, x, y);

		y += lineHeight;
	})
};

const setCanvasFillConfig = (canvas, heightStart) => {
	const baseLinesPositions = {
		0: 'top',
		1: 'middle',
		2: 'bottom',
		3: 'bottom',
		4: 'bottom'
	};

	canvas.textBaseline = baseLinesPositions[heightStart]
	canvas.font = '42px Ephesis';
	canvas.fillStyle = 'black';
	canvas.textAlign = 'center';
};
